module.exports = __webpack_public_path__ + "img/logo.2df40fb3.png";